import { DropDown, SearchBar, NewSiteButton } from "../components/textField";
import TopNav from "../components/topnav";
import EnhancedTable from "../components/newTable";
import { useState, useEffect, useMemo } from "react";
import Edit from '../assests/edit.png';
import { content } from "../utils/data";
import { getSurvey, createNewSurvey, getStatesDropDown, getLocationDropDown, getSiteDropDown, editSurvey, getUniqueNo } from "../api/serverApi";
import { Link, useLocation } from 'react-router-dom';
import { EditSurvey, SurveyForm } from "../components/dropdowns";
import SiteModal from "../components/siteCreationModal";
import Spinner from "../components/spinner";
import { Autocomplete, TextField } from "@mui/material";
import { useCookies } from "react-cookie";
import StatusModal from "../components/statusModal";
import { getValidAccessToken } from "../services/garphService";
import { useMsal } from "@azure/msal-react";
import * as microsoftTeams from "@microsoft/teams-js";
import { Button } from "@mui/material";

const SurveyManagment = () => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [siteNo, setSiteNo] = useState('');
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { siteId, siteName, state, locationName } = location.state || {};
  const responseData = [{ site_id: siteId, name: siteName, state: state, location_name: locationName }];
  const [surevyNo, setSurveyNo] = useState('');
  const [scheduleNo, setScheduleNo] = useState('');
  const [acres, setAcres] = useState('');
  const [guntas, setGuntas] = useState('');
  const [karabAcres, setKarabAcres] = useState('');
  const [karabGuntas, setKarabGuntas] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [site, setSite] = useState('');
  const [no, setNo] = useState('');
  const [survey, setSurvey] = useState(0);
  const [schedule, setSchedule] = useState('');
  const [landAcre, setLandAcre] = useState(0);
  const [landGunta, setLandGunta] = useState(0);
  const [karabLandAcre, setKarabaLandAcre] = useState(0);
  const [karabLandGunta, setKarabLandGunta] = useState(0);
  const [getState, setGetState] = useState([])
  const [getLocation, setGetLocation] = useState([])
  const [getSite, setGetSite] = useState([])
  const [selectedStateId, setSelectedStateId] = useState('');
  const [selectedLocationId, setSelectedLocationId] = useState('');
  const [selectedSiteId, setSelecteSiteId] = useState('');
  const [loading, setLoading] = useState(false);
  const [uniqueNo, setUniqueNo] = useState([]);
  const [selectedUnique, setSelectedUnique] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const { instance, accounts } = useMsal();
  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname"
  ]);

  useEffect(() => {
    if (siteId) {
      getUniqueNo({ site_id: siteId })
        .then((response) => {
          setUniqueNo(response.data);
          setSelectedUnique([]);
          console.log(response)
        }).catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          console.error('Error:', error);
          // setLoading(false);
        });
    } else {

      setUniqueNo([]);
    }
  }, []);

  const handleSurevyNo = (event) => {
    setSurveyNo(event.target.value);  // Captures text field input
  };
  const handleScheduleNo = (event) => {
    setScheduleNo(event.target.value);  // Captures text field input
  };
  const handleAreaAcres = (event) => {
    setAcres(event.target.value);  // Captures text field input
  };
  const handleAcresGuntas = (event) => {
    setGuntas(event.target.value);  // Captures text field input
  };
  const handleKarabAcres = (event) => {
    setKarabAcres(event.target.value);  // Captures text field input
  };
  const handleKarabGuntas = (event) => {
    setKarabGuntas(event.target.value);  // Captures text field input
  };

  const handleOpen = () => {
    setIsEditing(false);  // Ensure that isEditing is set to false for creating a new site
    setOpen(true);         // Open the modal for site creation
    // Optionally reset state-related fields

  };
  const handleClose = () => setOpen(false);

  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchSurvey = async () => {
      if (!siteId) return;

      setLoading(true);
      try {
        let token;
        if (isInTeams()) {
          // Get Teams SSO token
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ['https://graph.microsoft.com']
            });
          });
        } else {
          // Get MSAL token
          token = await getValidAccessToken(instance, accounts);
        }

        const res = await getSurvey(siteId, token);

       
        setFilteredRows(Array.isArray(res.data.sites) ? res.data.sites : []);
        setSiteNo(siteId);
      } catch (error) {
        const message = error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSurvey();
  }, [siteId, instance, accounts]);

  const rowsWithActions = useMemo(() => {
    return (filteredRows || []).map((row) => ({
      ...row,
      actions: (
        <div className="flex">
          <img
            src={Edit}
            alt="Edit"
            style={{ width: "20px", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(row.unique_survey_no)}
          />
        </div>
      ),
    }));
  }, [filteredRows]);

  const [searchText, setSearchText] = useState("");
  const rowsFiltered = useMemo(() => {
    const normalizedSearch = searchText.trim().replace(/\s+/g, ' ').toLowerCase();

    const searchFilter = (row) => {
      const searchContent = [
        row.name,
        row.state,
        row.location_name,
        row.description,
        row.unique_survey_no
      ]
        .map(val => String(val || "").replace(/\s+/g, ' ').toLowerCase())
        .join(" ");

      return normalizedSearch ? searchContent.includes(normalizedSearch) : true;
    };

    let filtered = rowsWithActions;

    if (selectedUnique && selectedUnique.length > 0) {
      const selectedNos = selectedUnique.map(item => String(item.unique_survey_no));
      filtered = filtered.filter(row => selectedNos.includes(String(row.unique_survey_no)));
    }

    return filtered.filter(searchFilter);
  }, [rowsWithActions, selectedUnique, searchText]);

  const handleSubmit = async () => {
    setLoading(true);
    if (!siteId || !surevyNo || !scheduleNo) {
      setResponseMessage("Please fill in all required fields: Site ID, Survey Number, and Schedule Number.");
      setIsSuccess(false);
      setModalOpen(true);
      setOpen(false);
      setLoading(false);
      return;
    }

    const toNumberOrNull = (val) => {
      if (val === "" || val === null || val === undefined) return null;

      const num = parseFloat(val); // ✅ Use this instead of Number + toFixed
      return isNaN(num) ? null : num;
    };

    const data = {
      site_id: siteId,
      survey_number: surevyNo,
      schedule: scheduleNo,
      acre: toNumberOrNull(acres),
      gunta: toNumberOrNull(guntas),
      karab_land_acre: toNumberOrNull(karabAcres),
      karab_land_gunta: toNumberOrNull(karabGuntas),
    };

    try {
      let token;
      if (isInTeams()) {
        // Get Teams SSO token
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ['https://graph.microsoft.com']
          });
        });
      } else {
        // Get MSAL token
        token = await getValidAccessToken(instance, accounts);
      }

      const response = await createNewSurvey(data, token);
      const newSite = response.data;

      if (newSite) {
        setFilteredRows((prev) => [...prev, newSite]);
       
        setSiteNo(siteId);
        setOpen(false);
        resetSurveyForm();

        // 🔁 Re-fetch survey list with fresh token
        const surveyResponse = await getSurvey(siteId, token);
        setFilteredRows(Array.isArray(surveyResponse.data.sites) ? surveyResponse.data.sites : []);

        // ✅ Refresh unique numbers
        if (siteId) {
          try {
            const uniqueRes = await getUniqueNo({ site_id: siteId });
            setUniqueNo(uniqueRes.data);
            setSelectedUnique([]);
            console.log("🔁 Unique numbers updated:", uniqueRes.data);
          } catch (error) {
            console.error("❌ Error fetching unique numbers:", error);
          }
        } else {
          setUniqueNo([]);
        }

        setResponseMessage(response.data?.message || "Survey created successfully");
        setIsSuccess(true);
      } else {
        console.error("⚠️ Invalid response from server:", response.data);
        setResponseMessage("Invalid server response");
        setIsSuccess(false);
      }

      setModalOpen(true);
    } catch (error) {
      console.error("❌ Error creating survey:", error);
      const details = error.response?.data?.detail;

      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);
      resetSurveyForm();
      setModalOpen(true);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const resetSurveyForm = () => {
    setSurveyNo('');
    setScheduleNo('');
    setAcres('');
    setGuntas('');
    setKarabAcres('');
    setKarabGuntas('');
  };

  useEffect(() => {
    // setLoading(true);
    getStatesDropDown(cookies.accessToken)
      .then((response) => {
        // Handle succesasful response
        setGetState(response.data);
      
        setSelectedLocationId('');
        setSelecteSiteId('');
        // setLoading(false);
      })
      .catch((error) => {
        // Handle error
        // setshowModal(true);
        // setModalTitle("Something went wrong, Please try again");
        console.error('Error:', error);
        // setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedStateId) {
      console.log("cookies.accessToken =", cookies.accessToken);
      getLocationDropDown(
  { state_id: selectedStateId },
  cookies.accessToken
)
        .then((response) => {
          setGetLocation(response.data);
          console.log(response)
        }).catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          console.error('Error:', error);
          // setLoading(false);
        });
    } else {
      setGetLocation([]);
      setSelectedLocationId('');
      setSelecteSiteId('');
    }
  }, [selectedStateId]);

  useEffect(() => {
    if (selectedLocationId) {
  getSiteDropDown(
  { location_id: selectedLocationId },
  cookies.accessToken
)
        .then((response) => {
          setGetSite(response.data);
          console.log(response)
        }).catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          console.error('Error:', error);
          // setLoading(false);
        });
    } else {
      setGetSite([]);
      setSelecteSiteId('');
    }
  }, [selectedLocationId]);

  const handleEdit = (surveyNo) => {
    const site = filteredRows?.find(site => site.unique_survey_no === surveyNo);

    if (site) {
      setSelectedStateId(site.state_id || '');
      setSelectedLocationId(site.location_id || '');
      setSelecteSiteId(site.site_id || '');
      setNo(site.unique_survey_no ?? '');
      setSurvey(site.survey_number ?? '');
      setSchedule(site.schedule ?? '');
      setLandAcre(site.acre ?? '');
      setLandGunta(site.gunta ?? '');
      setKarabaLandAcre(site.karab_land_acre ?? '');
      setKarabLandGunta(site.karab_land_gunta ?? '')
      setIsEditing(true);
      setOpen(true);
      console.log('Matched State:', site.state);
      console.log('Edit clicked for site:', site);
    } else {
      console.error('Site not found with ID:', siteId);
    }
  };

  const handleUniqueNo = (event) => {
    setSurvey(event.target.value);
  };
  const handleSchedule = (event) => {
    setSchedule(event.target.value);
  };
  const handleAcre = (event) => {
    setLandAcre(event.target.value); // ✅ allow decimals
  };

  const handleGunta = (event) => {
    setLandGunta(event.target.value); // ✅ allow decimals
  };

  const handleLandAcre = (event) => {
    setKarabaLandAcre(event.target.value); // ✅ allow decimals
  };

  const handleLandGunta = (event) => {
    setKarabLandGunta(event.target.value); // ✅ allow decimals
  };

  const handleSurvey = async () => {
    if (!selectedSiteId || !survey || !schedule) {
      setResponseMessage("Please fill in all required fields: Site ID, Survey Number, and Schedule Number.");
      setIsSuccess(false);
      setModalOpen(true);
      setOpen(false);
      setLoading(false);
      return;
    }

    const toNumberOrNull = (val) => {
      if (val === null || val === undefined) return null;

      const strVal = String(val).trim();
      if (strVal === "") return null;

      const num = parseFloat(strVal);
      return isNaN(num) ? null : num;
    };

    const data = {
      site_id: selectedSiteId,
      survey_number: survey,
      schedule: schedule,
      acre: toNumberOrNull(landAcre),
      gunta: toNumberOrNull(landGunta),
      karab_land_acre: toNumberOrNull(karabLandAcre),
      karab_land_gunta: toNumberOrNull(karabLandGunta),
    };
    setLoading(true);

    try {
      let token;
      if (isInTeams()) {
        // Get Teams SSO token
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ['https://graph.microsoft.com']
          });
        });
      } else {
        // Get MSAL token
        token = await getValidAccessToken(instance, accounts);
      }

      const response = await editSurvey(no, data, token);
      console.log("Survey updated successfully:", response.data);

      setResponseMessage(response.data?.message || "Survey updated successfully");
      setIsSuccess(true);
      setModalOpen(true);

      const res = await getSurvey(selectedSiteId, token);
      setFilteredRows(Array.isArray(res.data.sites) ? res.data.sites : []);
      setOpen(false);
    } catch (error) {
      console.error("Error updating or fetching survey:", error);
      const details = error.response?.data?.detail;

      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }
      setIsSuccess(false);
      setModalOpen(true);
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <TopNav />
      </div>
      <div className="px-[35px] py-2 font-bold text-2xl"><Link to='/sitecreation'>Site Creation</Link> {`>`} {state} {'>'} {locationName} {`>`} {siteName} {'>'} Survey Management </div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar value={searchText}
            onChange={(e) => setSearchText(e.target.value)} />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <Autocomplete
            multiple
            id="multi-select-unique-no"
            options={uniqueNo} // Array of options
            getOptionLabel={(option) => option.unique_survey_no} // Label shown in the dropdown
            value={selectedUnique} // This should be an array of selected items
            onChange={(event, newValue) => {
              console.log("newValue:", newValue);  // Log the new value
              setSelectedUnique(newValue);         // Update state with the new value
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Unique Survey No"
                placeholder="Select"
                size="small"
              />
            )}
            sx={{ width: 200 }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setSelectedUnique('');
            }}
            sx={{
              backgroundColor: '#1381B5',
              '&:hover': { backgroundColor: '#0f6c99' },
              width: "95px",
              height: '40px',
              fontSize: '10px',
              whiteSpace: 'nowrap', // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>
        <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
          <NewSiteButton Name="Add Survey" handleOpen={handleOpen} />
        </div>
      </div>
      <SiteModal
        open={open}
        handleClose={() => setOpen(false)}
        title={isEditing ? "Edit Survey" : "Survey Creation"}
        handleSubmit={isEditing ? handleSurvey : handleSubmit}
        formContent={isEditing ? (
          <EditSurvey
            isEditing={isEditing}
            responseData={getState}
            responseDataLocation={getLocation}
            responseDataSite={getSite}
            nameLocation="name"
            nameState="name"
            stateId="state_id"
            locationId="location_id"
            selectedSiteID="site_id"
            siteName="name"
            onChangeState={(e) => setSelectedStateId(e.target.value)}
            onChangeLocation={(e) => setSelectedLocationId(e.target.value)}
            onChangeSite={(e) => setSelecteSiteId(e.target.value)}
            selectedStateId={selectedStateId}
            selectedLocationId={selectedLocationId}
            siteId={selectedSiteId}
            uniqueNoId={survey}
            OSUiteNo={schedule}
            acre={landAcre}
            gunta={landGunta}
            karabAcre={karabLandAcre}
            karabGunta={karabLandGunta}
            onChangeUniqueNo={handleUniqueNo}
            onChangeOSUiteNo={handleSchedule}
            onChangeAcre={handleAcre}
            onChangeGunta={handleGunta}
            onChangeKarabAcre={handleLandAcre}
            onChangeKarabGunta={handleLandGunta}
            no={no}
          />
        ) : (
          <SurveyForm
            responseDataState={responseData}
            stateName="state"
            selectedState="state"
            selectedLocation="location_name"
            stateId={state}
            responseDataLocation={responseData}
            locationName="location_name"
            locationId={locationName}
            responseData={responseData}
            siteName="name"
            selectedSiteID="site_id"
            siteId={siteId}
            onChangeSurveyNo={handleSurevyNo}
            onChangeScheduleNo={handleScheduleNo}
            onChangeAcres={handleAreaAcres}
            onChangeGuntas={handleAcresGuntas}
            onChangeKarabAcres={handleKarabAcres}
            onChangeKarabGuntas={handleKarabGuntas}
          />
        )
        }
      />
      <div className="py-2 px-[35px]">
        <EnhancedTable
          rows={rowsFiltered}
          header={content.surveySite} // or whichever headers you're using
        />
      </div>
      {loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        message={responseMessage}
        isSuccess={isSuccess}
      />
    </>
  )
}

export default SurveyManagment

